import { useState } from 'react';
import { Row, Typography, Button, Modal } from 'antd';
import { useHistory } from 'react-router-dom';
import DeletionWarningModal from '../../components/Modal/DeletionWarningModal';
import AccountDeletionLayout from './AccountDeletionLayout';
import { button, cancelButton, row, linkButton } from './style';

const DeleteAccount = () => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const PrivacyPolicyLink =
    'https://www.anytime.gr/privacy-policy#shortdrive_greece';
  return (
    <AccountDeletionLayout>
      <Row>
        <Typography.Text style={row}>
          Ο λογαριασμός σου θα διαγραφεί άμεσα.Η συγκεκριμένη
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text>
          διαδικασία ειναι μη αναστρέψιμη. Αυτό σημαίνει ότι δε θα
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text>
          {' '}
          μπορείς να χρησιμοποιήσεις πλέον την εφαρμογή ούτε
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text>καμία από τις υπηρεσίες της.</Typography.Text>
      </Row>
      <Row style={row}>
        <Typography.Text>
          Σε περίπτωση οριστικής διαγραφής των δεδομένων της
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text>
          εφαρμογής η Ασφαλιστική Εταιρία ΙΝΤΕΡΑΜΕΡΙΚΑΝ έχει
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text>
          το δικαίωμα να καταγγείλει το ασφαλιστήριο συμβόλαιό
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text>σας σύμφωνα με τους όρους αυτού.</Typography.Text>
      </Row>
      <Row>
        <Typography.Text strong>
          Διευκρινίζεται ότι μετά τη διαγραφή, η ανανέωση του
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text strong>
          συμβολαίου σου δε θα πραγματοποιείται αυτόματα
        </Typography.Text>
      </Row>{' '}
      <Row>
        <Typography.Text strong>
          και θα χρειαστεί να γίνει έκδοση σε νέο short drive
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text strong>πρόγραμμα.</Typography.Text>
      </Row>
      <Row style={row}>
        <Typography.Text>
          Μπορείς να δεις περισσότερες λεπτομέρειες
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text>στην</Typography.Text>
        <Button
          type="link"
          style={linkButton}
          onClick={() => {
            window.open(PrivacyPolicyLink);
          }}
        >
          Πολιτική Απορρήτου
        </Button>

        <Typography.Text>ή στέλνοντας μας e-mail</Typography.Text>
      </Row>
      <Row>
        <Typography.Text>στο appdatadeletion@anytime.gr</Typography.Text>
      </Row>
      <Row justify="center">
        <Button
          style={{ ...button, marginTop: 50 }}
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          Συνέχεια
        </Button>
      </Row>
      <Row justify="center">
        <Button
          style={{
            ...cancelButton,
            paddingInline: 25
          }}
          type="link"
          onClick={() => {
            history.push('/');
          }}
        >
          Άκυρο
        </Button>
      </Row>
      <Modal
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        width={350}
        footer={null}
        style={{ top: 220 }}
      >
        <DeletionWarningModal setIsModalOpen={setIsModalOpen} />
      </Modal>
    </AccountDeletionLayout>
  );
};

export default DeleteAccount;
